(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dj-collection-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dj-collection-slideshow')) {
    customElements.define('dj-collection-slideshow', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.slides = [...this.querySelectorAll('.dj-banner__slide')];
        this.dots = [...this.querySelectorAll('[data-slide]')];
        this.index = 0;
        this.paused = this.dataset.autoplay !== 'true' || matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.hovered = false;
        this.editing = false;
        if (this.slides.length < 2) return;
        this.querySelector('.dj-banner__controls').hidden = false;
        this.pauseButton = this.querySelector('[data-pause]');
        this.updatePause();
        this.querySelector('[data-prev]').addEventListener('click', () => this.show(this.index - 1), options);
        this.querySelector('[data-next]').addEventListener('click', () => this.show(this.index + 1), options);
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.show(index), options));
        this.pauseButton.addEventListener('click', () => { this.paused = !this.paused; this.updatePause(); this.schedule(); }, options);
        this.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') { this.hovered = true; this.schedule(); } }, options);
        this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, options);
        this.addEventListener('focusin', () => this.schedule(), options);
        this.addEventListener('focusout', () => queueMicrotask(() => this.schedule()), options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        const surface = this.querySelector('.dj-banner__slides');
        surface.addEventListener('touchstart', e => { this.touch = e.touches.length === 1 ? { x: e.touches[0].clientX, y: e.touches[0].clientY } : null; clearTimeout(this.timer); }, { ...options, passive: true });
        surface.addEventListener('touchend', e => {
          if (this.touch) {
            const dx = e.changedTouches[0].clientX - this.touch.x;
            const dy = e.changedTouches[0].clientY - this.touch.y;
            if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) this.show(this.index + (dx < 0 ? 1 : -1));
          }
          this.touch = null;
          this.schedule();
        }, { ...options, passive: true });
        surface.addEventListener('touchcancel', () => { this.touch = null; this.schedule(); }, options);
        this.addEventListener('shopify:block:select', e => { const index = this.slides.indexOf(e.target.closest('.dj-banner__slide')); if (index >= 0) { this.editing = true; this.show(index); } }, options);
        this.addEventListener('shopify:block:deselect', () => { this.editing = false; this.schedule(); }, options);
        this.schedule();
      }
      updatePause() { this.pauseButton.textContent = this.paused ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel; }
      loadSlide(index) {
        const image = this.slides[index]?.querySelector('img[data-src]');
        if (!image || !image.dataset.src) return;
        image.src = image.dataset.src;
        if (image.dataset.srcset) image.srcset = image.dataset.srcset;
        if (image.dataset.sizes) image.sizes = image.dataset.sizes;
        delete image.dataset.src;
        delete image.dataset.srcset;
        delete image.dataset.sizes;
      }
      show(index) {
        this.index = (index + this.slides.length) % this.slides.length;
        this.loadSlide(this.index);
        this.slides.forEach((slide, i) => { slide.setAttribute('aria-hidden', String(i !== this.index)); slide.inert = i !== this.index; });
        this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.index)));
        this.schedule();
      }
      schedule() {
        clearTimeout(this.timer);
        clearTimeout(this.preloadTimer);
        if (!this.isConnected || this.paused || this.hovered || this.editing || document.hidden || this.contains(document.activeElement) || this.slides.length < 2) return;
        const delay = Number(this.dataset.interval) || 5000;
        const nextIndex = (this.index + 1) % this.slides.length;
        this.preloadTimer = setTimeout(() => this.loadSlide(nextIndex), Math.max(0, delay - 1200));
        this.timer = setTimeout(() => this.show(nextIndex), delay);
      }
      disconnectedCallback() { clearTimeout(this.timer); clearTimeout(this.preloadTimer); this.abort?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
